export default __webpack_public_path__ + "static/media/calendar.38c026af.svg";